import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_PAYMENT_MODES_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMedRefillPaymentModesRequestPayload,
  GetMedRefillPaymentModesResponsePayload,
} from '../types/getMedRefillPaymentModes.type';

export const TAG_MEDREFILL_PAYMENT_MODES = 'getMedRefillPaymentModes';

export const getMedRefillPaymentModes = <T extends BuilderType>(builder: T) =>
  builder.query<GetMedRefillPaymentModesResponsePayload, GetMedRefillPaymentModesRequestPayload>({
    providesTags: [TAG_MEDREFILL_PAYMENT_MODES],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_PAYMENT_MODES_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedRefillPaymentModesResponsePayload>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
